/* eslint-disable import/unambiguous */
import('./bootstrap');
